import React, { Component } from "react";
import { AlertModal } from "../AlertModal/AlertModal";
import './AutoCadastroUsuario.css';

export const ModalIntrucoesAtribuicao =

class extends Component {
	render() {
		return <AlertModal
          titulo={this.props.titulo}
		      visible={this.props.visible}
          handleClose={this.props.handleClose}
        >
          <div className="container-body">
            <p><b>Dirigente de TI</b> - Profissional responsável pela gestão estratégica da área de Tecnologia da Informação. Geralmente ocupa cargos como Diretor, Coordenador-Geral ou Coordenador, atuando na coordenação de projetos, equipes e recursos, com foco no alcance das metas institucionais.</p>
            <p><b>Responsável Técnico</b> - Encarregado por gerar as credenciais da API e por apoiar o órgão solicitante na integração, supervisionando processos, validando sistemas e assegurando conformidade técnica.</p>
          </div>
        </AlertModal>
	}

}